import { Button, Flex, Pill, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import qs from 'qs';

import { ResearchPerfEvalReport } from '@/module/ResearchPerfEval/model/ResearchPerfEvalTypes';

import { Content } from '@/core/components';

import { useCurrentUser } from '@feature/security';
import { Id } from '@feature/utils';
import { useUniversityAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';

export interface ResearchPerfEvalHeaderProps {
  evaluation: ResearchPerfEvalReport;
  hideSummary?: boolean;
}

const onDownload = (
  evaluationId: Id,
  facultyId: Id | null,
  departmentId: Id | null,
  disciplineId: Id | null,
  userId: Id | null,
) => {
  const query = qs.stringify({ facultyId, departmentId, disciplineId, userId }, { skipNulls: true });
  window.open(`/api/research-perf-evaluation/${evaluationId}/centralized-data/zip?${query}`);
};

export function ResearchPerfEvalHeader({ evaluation, hideSummary }: ResearchPerfEvalHeaderProps) {
  const { currentRole } = useCurrentUser();
  const hasAccess = ['DEPARTMENT_ADMIN', 'FACULTY_ADMIN', 'UNIVERSITY_ADMIN'].indexOf(currentRole) !== -1;

  const { facultyId, departmentId, disciplineId, userId } = useUniversityAdminHierarchy();
  const isButtonDisabled =
    !facultyId && !departmentId && !disciplineId && !userId && currentRole !== 'UNIVERSITY_ADMIN';
  return (
    <Content type="full">
      <Flex
        justify="center"
        align="center"
        gap="4px"
      >
        <Text fw="500">{evaluation.title}</Text>
        <Pill bg={evaluation.open ? 'green' : 'red'}>{evaluation.open ? 'Deschisă' : 'Închisă'}</Pill>
      </Flex>
      {hasAccess && !hideSummary && (
        <Flex
          justify="center"
          align="center"
          gap="10px"
        >
          <Button
            component={Link}
            to="."
            size="xs"
            disabled={isButtonDisabled}
            onClick={
              !isButtonDisabled
                ? () => onDownload(evaluation.id, facultyId, departmentId, disciplineId, userId)
                : undefined
            }
          >
            Rezultate centralizate
          </Button>
        </Flex>
      )}
    </Content>
  );
}
